import { Component, OnInit,AfterViewInit,ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, FormControlName, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CLASSIFICATIONS_LOOKUP } from '../core/models/classifications.model';
import { APPLICATION_REGISTER_MODEL } from '../core/models/application-register.model';
import { ADDRESS } from 'src/app/core/models/address.model';
import { Applicant } from 'src/app/core/models/applicant-model';
import { Contact } from 'src/app/core/models/contact.model';
import { ADDRESS_TYPES } from '../core/constants/global.constants';
import { CLASSIFICATIONS_DOMAIN_CODES, CLASSIFICATION_STATUS_CODES } from '../core/constants/status.constants';
import { CreditofferService } from '../services/creditoffer.service';
import { WantedcreditService } from '../services/wantedcredit.service';
import { HelperService } from '../services/helper.service';
import { LookupService } from '../services/lookup.service';
import { UtilityService } from '../services/utility.service';
import { windowWhen } from 'rxjs/operators';
import { PrivacyComponent } from '../privacy/privacy.component';
import { CONFIGURATIONS } from '../core/constants/global.constants';
import { SearchCriteria } from '../core/models/search-criteria';
import { ConfigService } from '../core/services/config.service';
import { error } from 'protractor';
import { ContactDetailsComponent} from '../common/components/contact-details/contact-details.component'
import { ROUTES } from '../common/constants';
@Component({
  selector: 'app-credit-offers',
  templateUrl: './credit-offers.component.html',
  styleUrls: ['./credit-offers.component.css']
})
export class CreditOffersComponent implements OnInit {
  @ViewChild('pricacy', { static: true }) privacyModal: PrivacyComponent;
  @ViewChild('primaryContact', { static: true }) primaryContactComponent: ContactDetailsComponent;
  @ViewChild('secondaryContact', { static: true }) secondaryContactComponent: ContactDetailsComponent;
  creditOfferFg: UntypedFormGroup;
  programDetailFg: UntypedFormGroup;
  declarationFgDetails: UntypedFormGroup;
  fgFiles: UntypedFormGroup;
  landholderDetailFg: UntypedFormGroup;
  creditOfferSaleFgDetails = new UntypedFormGroup({ creditsGroup: new UntypedFormGroup({})});
  classifications: CLASSIFICATIONS_LOOKUP[] = [];
  fileTypes: CLASSIFICATIONS_LOOKUP[] = [];
  deliveryMechanisms: CLASSIFICATIONS_LOOKUP[] = [];
  wantedCredits: any[] = [];
  subRegions: any[] = [];
  files: any[] = [];
  enableSubmit: boolean = false;
  offerData: any;
  offerNumber: string;
  offerId: number;
  //selectedFile: any;
  creditPrograms: any[]=[];
  maxFileSize2MB = 2097152;
  minFileSize120KB = 122880;
  validationErrors: any[] = [];
  creditHoldingLabel: string = "Credit holding ID";
  consentGiven: boolean = false;
  consent1: boolean = false;
  consent2: boolean = false;
  fileError: string = "";
  collapsedPanels: any = [false, false, false, false, false, false, false];
  
  //isCollapsed: boolean = false;
  constructor(public fb: UntypedFormBuilder, private apiService: CreditofferService,
    private helperService: HelperService,
    private router: Router,
    public toasterService: ToastrService, private wantedCreditsService: WantedcreditService,
    private utilityService: UtilityService, private lookupService: LookupService,
    private configService:ConfigService
  ) {
    window.scrollTo(0,0);
  }

  ngOnInit() {

    if (!this.hasRequiredWantedCreditData()) {
      this.router.navigateByUrl(ROUTES.wantedCredits);
      return;
    }

    // load classifications
    this.loadClassifications();
   
    this.generateCreditOfferFormGroup();
    this.generateDeclarationFg();
    this.generateFilesFormGroup();
    this.generateCreditOfferSaleFg();
    this.onChanges();
    // user may be navigating back and forth  between the wanted credits and the offer form - populate
    // previously entered values
    if (this.apiService.offerHeaderDetails != null) {
      const details = this.apiService.offerHeaderDetails;
        this.creditOfferFg.patchValue({
          deliveryMechanism: details.deliveryMechanism,
          creditOwnerId: details.creditOwnerId,
          agreementNumber: details.agreementNumber,
          boamsNumber: details.boamsNumber,
          //contactName: details.contactName,
          //contactLastName: details.contactLastName,
          //contactPhone: details.contactPhone,
          //contactMobile: details.contactMobile,
          //email: details.email,
          deliveryProgram: details.deliveryProgram,
          agreementStatus: details.agreementStatus,
          offsetScheme: details.offsetScheme,
          creditStatus: details.creditStatus,
          applicantName: details.applicantName,
          address1: details.address1,
          address2: details.address2,
          suburb: details.suburb,
          state: details.state,
          postCode: details.postCode,
          creditOwners: details.creditOwners,
          subRegion: details.subRegion,
        });
    }

    this.lookupService.ibraSubregions.subscribe(result => {
      this.subRegions = result;
    });
    //data from service may get lost when the user refresh the browser.
    //load the selected credits from the local storage if the data is not present
    if (this.wantedCreditsService.selectedCredits == null || this.wantedCreditsService.selectedCredits.length <= 0) {
      const ids = JSON.parse(localStorage.getItem("credits"));
      if (ids != null) {
        var searchCriteria: SearchCriteria = { ids: ids };
        this.wantedCreditsService.search(searchCriteria).subscribe(result => {
          const { results } = result; 
          this.wantedCreditsService.selectedCredits = results;
          this.wantedCredits = results;
          this.GenerateDynamicControls();
        });
      }
    }
    else {
      this.wantedCredits = this.wantedCreditsService.selectedCredits;
      this.GenerateDynamicControls();
    }

    this.loadApplicant();
    this.loadPrograms();

  }

  private hasRequiredWantedCreditData() {
    return this.wantedCreditsService.requestId && 
    (this.wantedCreditsService?.selectedCredits.length || localStorage.getItem("credits"));
  }

  onChanges(): void {
    this.creditOfferFg.valueChanges.subscribe(val => {
      this.apiService.offerHeaderDetails = this.creditOfferFg.value;
      
    });
  }

  GenerateDynamicControls() {
    if (this.wantedCredits == null) return;
    this.wantedCredits.map((item, index) => {
      var numnerOfCredits = item.offeredCredits != null
        && item.offeredCredits != undefined ? item.offeredCredits : item.numberOfCredits
      var credit = this.fb.group({
        numberOfCredits: new UntypedFormControl(numnerOfCredits),
        bidPrice: new UntypedFormControl(item.bidPrice != null && item.bidPrice !=undefined?item.bidPrice:0),
        dpieCreditId: new UntypedFormControl()
      });

      this.creditsGroup.addControl(index.toString(), credit);

    });
  }

  get creditsArray(): any {
    return this.creditOfferSaleFgDetails.get('creditsArray') as UntypedFormArray;
  }

  get creditsGroup(): any {
    return this.creditOfferSaleFgDetails.get('creditsGroup') as UntypedFormGroup;
  }

  get showBidPrice(): boolean {
    return this.creditOfferFg.value.deliveryMechanism == "TDR";
  }

  get isExistingCredit(): boolean {
    return this.creditOfferFg.value.creditStatus == "E";
  }

  get allowOffers():boolean {
    return this.creditPrograms != null && this.creditPrograms.length >= 1;
  }

  get showLandholderDetails(): boolean {
    return this.creditOfferFg.value.creditStatus=="P";
  }

  get showOwnerDetails(): boolean {
    const creditStatus = this.creditOfferFg.value.creditStatus;
    return creditStatus=="" || creditStatus == "E";
  }

  get filteredFileTypes(): any {
    if (this.fileTypes == null) return null;
    if (this.creditOfferFg.value.deliveryMechanism == "TDR")
      return this.fileTypes.filter(f => f.code != "FA");
    else return this.fileTypes;
    
  }

  get schemeReadOnly(): boolean {
    return this.creditOfferFg.value.agreementStatus == "P";
  }

  get deliveryMechamismName(): string {
    const dm = this.creditOfferFg.value.deliveryMechanism;
    if (dm == "TDR") return "Tender";
    else if (dm == "OFPO") return "Open fixed price offer";
    else return "";

  }

  get programName(): string {
    if (this.creditPrograms == null) return "";
    const prg = this.creditPrograms[0];
    return prg == null ? "" : prg.name;
  }

  consentChanged($event) {
    this.consent1 = $event.target.checked
    this.consentGiven = this.consent1 && this.consent2;
  }
  consent2Changed($event) {
    this.consent2 = $event.target.checked
    this.consentGiven = this.consent1 && this.consent2;
  }
  calculateTotalPrice(index: number) {
    if (!this.showBidPrice) return;
    var formGroup = this.creditsGroup.controls[index];
    var credit = this.wantedCredits[index];
    if (credit != null) {
      var bidPrice = Number(formGroup.get("bidPrice").value);
      if (isNaN(bidPrice)) bidPrice = 0;
      credit.bidPrice = bidPrice;
      credit.totalBidPrice = Number(formGroup.get("numberOfCredits").value) * bidPrice;
    } 
  }

  ValidateNumberOfCredits(index: number) {
    var formGroup = this.creditsGroup.controls[index];
    if (formGroup == null) return;
    var credits = Number(formGroup.get("numberOfCredits").value);
    if (isNaN(credits)) return;
    var credit = this.wantedCredits[index];
    if (credit == null) return;
    var maxAlllowedQty = Number(credit.numberOfCredits);
    if (isNaN(maxAlllowedQty)) maxAlllowedQty = 0;
    if (credits > maxAlllowedQty) formGroup.get("numberOfCredits").setValue(maxAlllowedQty);
    credit.offeredCredits = credits;
    this.calculateTotalPrice(index);
  }

  loadPrograms() {
    this.lookupService.Programs.subscribe(result => {
      this.creditPrograms = result;
      if (this.creditPrograms != null && this.creditPrograms.length == 1) {
        const prgm = this.creditPrograms[0];
        if (prgm == null) return;
        this.creditOfferFg.patchValue({
          deliveryProgram: prgm.id,
          deliveryMechanism: prgm.purchaseMethod
        });
      }
    });
   
  }

  loadClassifications(): void {
    const deliveryMechanismCode = 'OFRDM';
    const classificationTypes = [CLASSIFICATIONS_DOMAIN_CODES.OF.CODE,deliveryMechanismCode];
    this.lookupService.getClassifications(classificationTypes).subscribe((res: CLASSIFICATIONS_LOOKUP[]) => {
      if (res && res.length) {
        this.classifications = res;
        this.fileTypes = this.classifications.filter((classification: CLASSIFICATIONS_LOOKUP) => classification.parentCode === CLASSIFICATIONS_DOMAIN_CODES.OF.CODE);
        this.deliveryMechanisms = this.classifications.filter((classification: CLASSIFICATIONS_LOOKUP) => classification.parentCode === deliveryMechanismCode);
      }
    });

  }

  
  loadApplicant(): void {
    
    if (this.apiService.creditDetails != null) {
      this.creditOfferFg.patchValue({
        creditOwnerId: this.apiService.creditDetails.creditOwnerId
        /*contactName: this.apiService.creditDetails.contactName,
        contactPhone: this.apiService.creditDetails.contactPhone,
        contactMobile: this.apiService.creditDetails.contactMobile,
        email: this.apiService.creditDetails.email,*/
        
      });

      //set primay and setconday contat
      if (this.apiService.primaryContact != null) this.primaryContactComponent.setContact(this.apiService.primaryContact);
      if (this.apiService.secondaryContact != null) this.secondaryContactComponent.setContact(this.apiService.secondaryContact);
    }
    //document.getElementById('deliveryMechanism').focus();
  }

  generateCreditOfferFormGroup() {
    this.creditOfferFg = this.fb.group({
      id: [0],
      creditOwnerId: ['', Validators.compose([Validators.maxLength(20)])],
      agreementNumber: ['', Validators.compose([Validators.maxLength(25)])],
      boamsNumber: ['', Validators.compose([Validators.maxLength(25)])],
      //contactName: ['', Validators.compose([Validators.required, Validators.maxLength(51)])],
      //contactLastName: ['', Validators.compose([Validators.required,Validators.maxLength(51)])],
      //contactPhone: ['', Validators.compose([Validators.maxLength(15)])],
      //contactMobile: ['', Validators.compose([Validators.maxLength(15)])],
      //email: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.email])],
      deliveryMechanism: ['', Validators.compose([Validators.required])],
      deliveryProgram: ['', Validators.compose([Validators.required])],
      agreementStatus: [''],
      offsetScheme: [''],
      creditStatus: [''],
      applicantName: ['', Validators.compose([Validators.maxLength(250)])],
      address1: ['', Validators.compose([Validators.maxLength(50)])],
      address2: ['', Validators.compose([Validators.maxLength(50)])],
      suburb: ['', Validators.compose([Validators.maxLength(50)])],
      state: ['', Validators.compose([Validators.maxLength(5)])],
      postCode: ['', Validators.compose([Validators.maxLength(5)])],
      creditOwners: ['', Validators.compose([Validators.maxLength(250)])],
      subRegion: ['', Validators.compose([Validators.required])],
    });
  }

  generateAddressFg(): UntypedFormGroup {
    return this.fb.group({
      address1: [''],
      address2: [''],
      /*address3: [''],*/
      suburb: [''],
      state: [''],
      postCode: [''],
      country: [''],
      id: [0],
      type: ['']
    });
  }

  generateDeclarationFg() {
    this.declarationFgDetails = this.fb.group({
      authoriserName: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      position: [''],
      organisation:[''],
      authOption:['self']

    })
  }

  generateCreditOfferSaleFg() {
    this.creditOfferSaleFgDetails = this.fb.group({
      totalCredits: [0, Validators.required],
      creditsArray: new UntypedFormArray([]),
      creditsGroup: new UntypedFormGroup({})
    })
  }

  generateFilesFormGroup() {
    this.fgFiles = this.fb.group({
      fileType: ['', Validators.compose([Validators.required])],
      fileName: ['', Validators.compose([Validators.maxLength(100)])],
      file: ['', Validators.compose([Validators.required])]
    });
  }

  generateLandholderFormGroup() {
    this.landholderDetailFg = this.fb.group({
      applicantName: ['', Validators.compose([Validators.required, Validators.maxLength(250)])],
      address1: ['', Validators.compose([Validators.maxLength(50)])],
      address2: ['', Validators.compose([Validators.maxLength(50)])],
      suburb: ['', Validators.compose([Validators.maxLength(50)])],
      state: ['', Validators.compose([Validators.maxLength(5)])],
      postCode: ['', Validators.compose([Validators.maxLength(5)])]
    });
  }

  generateProgramDetailsFormGroup() {
    this.programDetailFg = this.fb.group({
      programId: ['', Validators.compose([Validators.maxLength(10)])]
    });
  }

  get creditHolder(): Applicant {
    var details: APPLICATION_REGISTER_MODEL = {};
    details = this.creditOfferFg.value;
    let primaryContact = this.primaryContactComponent.getContact();
    primaryContact.type = "P";
    let secondaryContact = this.secondaryContactComponent.getContact();
    secondaryContact.type = "S";
    let contacts: Contact[] = [];
    contacts.push(primaryContact);
    if (secondaryContact.firstName != null && secondaryContact.firstName.trim() != "") {
      if (secondaryContact.email != null && secondaryContact.email.trim() == "") secondaryContact.email = null;
      contacts.push(secondaryContact);
      
    }
    
    var creditHolder = {
      id: 0,
      creditOwnerId: details.creditOwnerId,
      firstName: primaryContact.firstName,
      //contactName: details.contactName,
      //contactLastName:details.contactLastName,
      //contactPhone: details.contactPhone,
      //email: details.email,
      boamsNumber: details.boamsNumber,
      contacts:contacts
    };

    return creditHolder;
  }

  updateDeliveryWithBillingAddress(event: any): void {
    if (event.target.checked) {
      const billingAdress: ADDRESS = this.creditOfferFg.get('billingAddress').value;
      this.creditOfferFg.get('deliveryAddress').patchValue({
        address1: billingAdress && billingAdress.address1,
        address2: billingAdress && billingAdress.address2,
        suburb: billingAdress && billingAdress.suburb,
        state: billingAdress && billingAdress.state,
        postCode: billingAdress && billingAdress.postCode,
        country: billingAdress && billingAdress.country,
      });

    }
  }

  selectDocument(event) {
    const selectedFile = event.target.files[0];
    this.fileError = "";
    const fileName = selectedFile.name;
    var validFile= false;
    const extension = fileName.substr(fileName.lastIndexOf('.'));
    var lower = extension != null ? extension.toLowerCase() : "";

    
    const size = selectedFile.size;
   
    if (CONFIGURATIONS.FileTyesAllowed.findIndex(val => val == lower) >= 0) {
      validFile = true;
    }
    else {
      this.fileError = "Only Pdf and Word documents are allowed.";
      return false;
    }
    
    if (validFile && size <= CONFIGURATIONS.MaxFileSize * 1024 * 1024) validFile = true
    else {
      this.fileError = "File size exceeds max limit of " + CONFIGURATIONS.MaxFileSize.toString() + " MB";
      return false;
    } 

    if (validFile ) {
      this.fgFiles.get('file').setValue(selectedFile);
      this.fgFiles.get('fileName').setValue(selectedFile.name);
      return true;
    }
  }

  save() {
    var details: APPLICATION_REGISTER_MODEL = {};
    details = this.creditOfferFg.value;
    this.apiService.creditDetails = details;
    this.apiService.primaryContact = this.primaryContactComponent.getContact();
    this.apiService.secondaryContact = this.secondaryContactComponent.getContact();
    this.router.navigateByUrl('/wanted-credits');
  }

  submit(): void {
    const errorMessage = "Unable to save offer applicant details.";
    if (!this.isValidOffer) {
      var el = document.getElementById('wantedCreditsDiv');
      if (el!=undefined && el!=null) el.scrollIntoView({ behavior: 'smooth' });
      return
    };
    var creditOffer = {
      offerNumber: null,
      applicantId: 0,
      applicant: this.creditHolder,
      credit: null,
      creditOwnerId: this.creditOfferFg.value.creditOwnerId,
      authoriserName: this.declarationFgDetails.value.authoriserName,
      authoriserPosition: this.declarationFgDetails.value.position,
      authoriserOrganisation: this.declarationFgDetails.value.organisation,
      authorisationOption: this.declarationFgDetails.value.authOption,
      programId: this.creditOfferFg.value.deliveryProgram,
      deliveryMechanism: this.creditOfferFg.value.deliveryMechanism,
      agreementNumber: this.creditOfferFg.value.agreementNumber,
      agreementStatus: this.creditOfferFg.value.agreementStatus,
      creditStatus: this.creditOfferFg.value.creditStatus,
      creditScheme: this.creditOfferFg.value.offsetScheme,
      creditOwners: this.creditOfferFg.value.creditOwners

    }
    var creditOfferSite = {
      firstAnnualManagementPayment: null,
      offerId: null,
      siteNumber: null,
      siteEstablishedDate: null,
      underActiveManagement: false,
      complianceStatus: null,
      CreditOwnerID: null,
      name: this.creditOfferFg.value.applicantName,
      address1: this.creditOfferFg.value.address1,
      address2: this.creditOfferFg.value.address2,
      suburb: this.creditOfferFg.value.suburb,
      state: this.creditOfferFg.value.state,
      postcode: this.creditOfferFg.value.postCode
    }
    var creditIds: any = [];

    this.wantedCredits.map((item, index) => {
      var qtyTextBox = this.creditsGroup.controls[index].get("numberOfCredits");
      var priceTextBox = this.creditsGroup.controls[index].get("bidPrice");
      var dpieCreditTextBox = this.isExistingCredit ? this.creditsGroup.controls[index].get("dpieCreditId") : null;
      creditIds.push({
        id: item.id,
        AvailableCredits: qtyTextBox != null && qtyTextBox != undefined ? Number(qtyTextBox.value) : item.numberOfCredits,
        WantedCredits: item.numberOfCredits,
        bidPrice: priceTextBox != null && priceTextBox != undefined ? Number(priceTextBox.value) : 0,
        dpieCreditId: dpieCreditTextBox != null ? dpieCreditTextBox.value:""
      })
    })

    
   
    var creditOfferViewModel = {
      requestId: this.wantedCreditsService.requestId,
      creditOffer: creditOffer,
      creditIds: creditIds,//this.wantedCredits.map(res=> res.id),
      creditOfferSite: creditOfferSite,
      creditOfferFiles: this.files,
      SubregionId: this.creditOfferFg.value.subRegion
    }

    this.apiService.save(creditOfferViewModel).subscribe(result => {
      if (result != null) {

        this.offerData = JSON.parse(result);
        this.apiService.creditDetails = JSON.parse(result);
        this.reset();
        this.resetObjects();
        this.apiService.offerConfirmationNumber = this.offerData.item1;
        //reset the wanted credits variables
        this.wantedCreditsService.requestId = null;
        this.wantedCreditsService.selectedCredits = null;
        localStorage.clear();
        this.router.navigateByUrl('/confirm');
        
      }

    }, error => {
      this.toasterService.error(errorMessage);
    });

  }

  deleteWantedCredit(event, $event: any) {
    $event.preventDefault();
    const modalOptions: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef: NgbModalRef = this.utilityService.openModal('CONFIRMATION_MODAL', 'DELETE_CONFIRMATION', modalOptions);
    modalRef.result.then((respnse) => {
      if (respnse) {
        const index: number = this.wantedCredits.indexOf(event);
        if (index !== -1) {
          this.wantedCredits.splice(index, 1);
          //Delete form controls that were generated dynamically
          this.GenerateDynamicControls();
          if (this.wantedCredits != null && this.wantedCredits.length > 0) {
            var ids: any = [];
            this.wantedCredits.map((item, index) => { ids.push(item.id) });
            localStorage.setItem('credits', JSON.stringify(ids));
          }
          else {
            localStorage.removeItem('credits');
          }
          
        }
      }
    });
  }

  deleteFile(event) {
    const modalOptions: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef: NgbModalRef = this.utilityService.openModal('CONFIRMATION_MODAL', 'DELETE_CONFIRMATION', modalOptions);
    modalRef.result.then((respnse) => {
      if (respnse) {
        const index: number = this.files.indexOf(event);
        if (index !== -1) {
          this.files.splice(index, 1);
        }
      }
    });
  }
   

  get offerTextboxList(): UntypedFormArray {
    return this.creditOfferSaleFgDetails.get('creditsArray') as UntypedFormArray;
  }

  reset() {
    this.creditOfferFg.reset();
    this.declarationFgDetails.reset();
    this.fgFiles.reset();
    //this.landholderDetailFg.reset();
  }

  resetObjects() {
    this.wantedCreditsService.selectedCredits.splice(0, this.wantedCreditsService.selectedCredits.length);
    this.apiService.creditDetails = null;
    this.apiService.cAddress = null;
    this.apiService.pAddress = null;
  }

  AddFile(): void {
    if (this.fgFiles.valid) {
      //try uploading the file
      if (this.fgFiles.valid) {
        this.helperService.setLoader(true);
        const formDta = new FormData();

        formDta.append('uploadedDoc', this.fgFiles.get('file').value);
        this.apiService.uploadFile(formDta, this.wantedCreditsService.requestId).subscribe(result => {
          this.helperService.setLoader(false);
          var creditOffer = {
            offerId: 0,
            FileTypeId: this.fgFiles.value.fileType,
            fileName: this.fgFiles.value.fileName,
            cM9Reference: null
          }
          this.files.push(creditOffer);
          this.fgFiles.reset();
        }, error => {
            this.helperService.setLoader(false);
            this.toasterService.error("File upload failed. Please try again.");
        });
     
      }
      
    }
  }

  getFileType(id: number):string {
    let fileType = this.classifications.filter(res => res.id == id).map(result => result.name);
    return fileType[0];
  }

  get isValidOffer(): boolean {
    this.validationErrors = [];
    var isValid = true;
    var deliveryMechanism = this.creditOfferFg.value.deliveryMechanism;
    this.wantedCredits.map((item, index) => {
      var qtyTextBox = this.creditsGroup.controls[index].get("numberOfCredits");
      if (qtyTextBox == null || qtyTextBox == undefined) {
        isValid = false;
        this.validationErrors.push("Please enter number of credits.");
        return;
      };
      var numCredits = Number(qtyTextBox.value);
      if (isNaN(numCredits) || numCredits <= 0) {
        isValid = false;
        this.validationErrors.push("Minimun number of credits offered should be 1.");

      }
      //price is only valid for Tender offers
      if (deliveryMechanism == "TDR") {
        var priceTextBox = this.creditsGroup.controls[index].get("bidPrice");
        if (priceTextBox == null || priceTextBox == undefined) {
          isValid = false;
          this.validationErrors.push("Please enter your bid price.");
          return;
        }
        var price = Number(priceTextBox.value);
        if (isNaN(price) || price <= 0) {
          isValid = false;
          this.validationErrors.push("Bid price should be greater than $0.");
          return;
        }
      }
      
   
    })
    return isValid;
  }

  openPrivacy($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.privacyModal.open();
  }

  toggleCollapse(headerNumber: number) {
    this.collapsedPanels[headerNumber] = !this.collapsedPanels[headerNumber];
    
  }

  isCollapsed(headerNumber: number):boolean {
    return this.collapsedPanels[headerNumber];
  }

  schemeChanged($event:any) {
    if ($event == null || $event == undefined) return;
    if ($event.target.value == "BBAM") {
      this.creditOfferFg.patchValue({
        "creditStatus": "E"
      });
    }
    else {
      this.creditOfferFg.patchValue({
        "creditStatus": ""
      });
    }
  }

  agreementChanged($event: any) {
    if ($event == null || $event == undefined) return;
    if ($event.target.value == "P") {
      this.creditOfferFg.patchValue({
        "agreementNumber": "NA",
        "creditStatus": "P",
        "offsetScheme": "BAM"
      });
    }
    else {
      //reset the value if NA is entered
      if (this.creditOfferFg.value.agreementNumber == "NA") {
        this.creditOfferFg.patchValue({
          "agreementNumber": ""
        });
      }
      this.creditOfferFg.patchValue({
        "creditStatus": ""
      });
    }
  }
}


